import { Routes } from '@angular/router'

import { FeatureType, RouteUtil } from '../shared'
import { ActionsComponent } from './actions/actions.component'
import { BusinessPlanSectionsComponent } from './business-plan-sections/business-plan-sections.component'
import { CompanyQuartersComponent } from './company-quarter/company-quarters.component'
import { QuarterlyMeasurablesComponent } from './quarterly-measurables/quarterly-measurables.component'
import { CountiesComponent } from './counties/counties.component'
import { DivisionsComponent } from './divisions/divisions.component'
import { FuelRecordDefaultsComponent } from './fuel-record-default/fuel-record-defaults.component'
import { AiPocComponent } from './ai-poc/ai-poc.component'
import { HcssApiTestComponent } from './hcss-api-test/hcss-api-test.component'
import { JobTypesComponent } from './job-type/job-types.component'
import { MetricsComponent } from './metrics/metrics.component'
import { ProcureToPayComponent } from './plans/procure-to-pay/procure-to-pay.component'
import { RolesComponent } from './roles/roles.component'
import { UsersComponent } from './users/users.component'
import { ValidationComponent } from './validation/validation.component'
import { VendorsComponent } from './vendors/vendors.component'
import { VistaUploadsComponent } from './vista-uploads/vista-uploads.component'

export const adminRoutes: Routes = [
    {
        path: 'admin',
        children: [
            RouteUtil.Make('users', UsersComponent, FeatureType.UsersView),
            RouteUtil.Make('roles', RolesComponent, FeatureType.RolesRightsView),
            RouteUtil.Make('actions', ActionsComponent, FeatureType.UsersView),
            RouteUtil.Make('validation', ValidationComponent, FeatureType.UsersView),
            RouteUtil.Make('jobtypes', JobTypesComponent, FeatureType.UsersView),
            RouteUtil.Make('counties', CountiesComponent, FeatureType.UsersView),
            RouteUtil.Make('divisions', DivisionsComponent, FeatureType.AdminDivisionsView),
            RouteUtil.Make('fuel-record-defaults', FuelRecordDefaultsComponent, FeatureType.EquipmentFuelEntryEdit),
            RouteUtil.Make('vendors', VendorsComponent, FeatureType.UsersView),
            RouteUtil.Make('company-quarters', CompanyQuartersComponent, FeatureType.UsersView),
            RouteUtil.Make('quarterly-measurables', QuarterlyMeasurablesComponent, FeatureType.UsersView),
            RouteUtil.Make('metrics', MetricsComponent, FeatureType.UsersView),
            RouteUtil.Make('business-plan-sections', BusinessPlanSectionsComponent, FeatureType.UsersView),
            RouteUtil.Make('hcss-api-test', HcssApiTestComponent, FeatureType.UsersView),
            RouteUtil.Make('ai-poc', AiPocComponent, FeatureType.UsersView),
            RouteUtil.Make('vista-uploads', VistaUploadsComponent, FeatureType.AdminVistaUploadsView),
            RouteUtil.Make('plans/procure-to-pay', ProcureToPayComponent, FeatureType.AdminPlansView),
        ],
    },
]
